import React, { useState } from 'react';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';
import ForgotPasswordForm from './ForgotPasswordForm';
import './AuthModal.css';

function AuthModal({ isOpen, onClose, onSuccess }) {
  const [view, setView] = useState('login'); // 'login', 'register', 'forgot-password'

  if (!isOpen) return null;

  const handleSuccess = () => {
    if (onSuccess) onSuccess();
    onClose();
    // Réinitialiser la vue à login pour la prochaine ouverture
    setView('login');
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
      setView('login'); // Réinitialiser à login
    }
  };

  const handleClose = () => {
    onClose();
    setView('login'); // Réinitialiser à login
  };

  return (
    <div className="auth-modal-overlay" onClick={handleOverlayClick}>
      <div className="auth-modal-card">
        <button className="modal-close-button" onClick={handleClose}>
          ✕
        </button>
        
        <div className="auth-modal-content">
          {view === 'login' && (
            <LoginForm
              onSuccess={handleSuccess}
              onSwitchToRegister={() => setView('register')}
              onSwitchToForgotPassword={() => setView('forgot-password')}
            />
          )}
          {view === 'register' && (
            <RegisterForm
              onSuccess={handleSuccess}
              onSwitchToLogin={() => setView('login')}
            />
          )}
          {view === 'forgot-password' && (
            <ForgotPasswordForm
              onSwitchToLogin={() => setView('login')}
              onSuccess={handleSuccess}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default AuthModal;












